module.exports = __webpack_public_path__ + "static/images/hb.049bbd8.jpg";